export default __webpack_public_path__ + "static/media/gifchat2.fb2346bf.gif";